module.exports = __webpack_public_path__ + "visa.fe7bd6.svg";